const utils = {
  getQueryString: function(name) {
    var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
    var r = window.location.search.substr(1).match(reg);
    if (r != null) return unescape(r[2]); return '';
  },
  fixJump: function(param){
    let ua = navigator.userAgent;
    if(!ua.match(/cfbondclient/gi)) {
      if(ua.match(/micromessenger/gi)) {
        if(!document.getElementById('shadowBox')) {
          var coverdiv = document.createElement('div');
          coverdiv.id="shadowBox";
          document.body.appendChild(coverdiv);
          document.getElementById('shadowBox').addEventListener('touchmove',function(e){
            e.preventDefault()
            e.stopPropagation()
          })
          document.getElementById('shadowBox').onclick=function(){
            document.getElementById('shadowBox').remove()
          }
        }
      } else {
        if(!ua.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/gi)){
          window.location.href = 'zgcf://com.cfbond.acfw/applinks?id='+param.id+'&mode='+param.mode
        } else {
          window.location.href = 'ioscfbond://com.cfbond.zgcfw/applinks?id='+param.id+'&mode='+param.mode
        }
        setTimeout(function(){
          window.location.href='http://share.cfbond.com'
        },2000)
      }
    }
  },
  fixJumpHome: function(){
    let ua = navigator.userAgent;
    if(!ua.match(/cfbondclient/gi)) {
      if(ua.match(/micromessenger/gi)) {
        if(!document.getElementById('shadowBox')) {
          var coverdiv = document.createElement('div');
          coverdiv.id="shadowBox";
          document.body.appendChild(coverdiv);
          document.getElementById('shadowBox').addEventListener('touchmove',function(e){
            e.preventDefault()
            e.stopPropagation()
          })
          document.getElementById('shadowBox').onclick=function(){
            document.getElementById('shadowBox').remove()
          }
        }
      } else {
        if(!ua.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/gi)){
          window.location.href = 'zgcf://com.cfbond.acfw/applinks'
        } else {
          window.location.href = 'ioscfbond://com.cfbond.zgcfw/applinks'
        }
        setTimeout(function(){
          window.location.href='http://share.cfbond.com'
        },2000)
      }
    }
  },
  delWxfmt: function(str){
    if(typeof str === 'string') {
      str = str.replace(/\wx_fmt=[a-zA-Z]{0,4}/gi,'')
    }
    return str
  },
  NEWS_TEXT:{
    0: '',
    1: '置顶',
    2: '热点',
    3: '独家',
    4: '原创',
    5: '评论',
    6: '解读',
    7: '快讯',
    8: '预告',
    9: '直播',
    10: '专题',
    11: '广告'
  },
  changeMeta: function(_name, _content){
    try{
      document.querySelector('meta[name="'+_name+'"]').setAttribute('content',_content)
    } catch(err) {
      console.log(err)
    }
  },
  loadTRStat(_contentid, _publishdate, _author, _source){
    this.changeMeta('contentid', _contentid)
    this.changeMeta('publishdate', _publishdate)
    this.changeMeta('author', _author)
    this.changeMeta('source', _source)
    try {
      window.wd_paramtracker("_wdxid=000000000000000000000000000000000000000000")
    } catch(err){
      console.log(err)
    }
  }
}

export default utils
  